export const formatRowMoney = (value: number): string => {
  if (value >= 1e9) {
    return `$${(value / 1e9).toFixed(2)}B`;
  }

  if (value >= 1e6) {
    return `$${(value / 1e6).toFixed(value >= 1e7 ? 0 : 1)}M`;
  }

  if (value >= 1e3) {
    return `$${Math.round(value / 1e3)}K`;
  }

  return `$${Math.round(value)}`;
};
